import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';

@JsonObject('model.project.LinkedTxn')
export class LinkedTxn extends AbstractModel {

    @JsonProperty(String, 'txnId')
    txnId: string;

    @JsonProperty(String, 'txnLineId')
    txnLineId?: string;

    @JsonProperty(String, 'txnType')
    txnType: string;

}
